<template>
  <div id="chats">
    <Navbar current="Psicólogos" />
    <Sidebar />
    <Container col="col-12">
      <Header :headerClass="'mb-0'" :headerBodyClass="'pb-0 border-0'" :isSubHeader="false" title="Psicólogos"
        subtitle="Registro dos psicólogos" :iconClass="'fas fa-user-md text-primary'" :totalCount="totalPsiCount">

        <template slot="button">
          <div class="d-flex align-items-end gap-3">
            <div>
              <label class="form-label text-muted mb-1" style="font-size: 0.75rem">Data de cadastro</label>
              <select
                class="form-select form-select-sm"
                v-model="dateFilter"
                @change="dateFilterChanged(dateFilter)"
              >
                <option v-for="opt in dateFilterOptions" :key="opt.id" :value="opt.id">{{ opt.title }}</option>
              </select>
            </div>
            <div>
              <label class="form-label text-muted mb-1" style="font-size: 0.75rem">Cadastro de</label>
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="customDateFrom"
                @change="customDateChanged()"
              />
            </div>
            <div>
              <label class="form-label text-muted mb-1" style="font-size: 0.75rem">Cadastro até</label>
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="customDateTo"
                @change="customDateChanged()"
              />
            </div>
          </div>
        </template>
      </Header>

      <!-- Pills de filtro -->
      <div class="pills-wrap mt-4 mb-3">
        <button
          v-for="pill in pills"
          :key="pill.id"
          type="button"
          class="filter-pill"
          :class="selectedPill === pill.id ? 'filter-pill--active' : 'filter-pill--idle'"
          @click="selectPill(pill.id)"
        >
          {{ pill.name }}
          <span class="pill-badge">{{ countFor(pill) }}</span>
        </button>
      </div>

      <!-- Resumo do filtro ativo -->
      <p class="text-muted small mb-4">
        Filtrando por: <strong class="text-body">{{ activePill.name }}</strong>
        <template v-if="dateFilters.date_from || dateFilters.date_to">
          · cadastro
          <template v-if="dateFilters.date_from">de {{ $moment(dateFilters.date_from).format("DD/MM/YYYY") }}</template>
          <template v-if="dateFilters.date_to"> até {{ $moment(dateFilters.date_to).format("DD/MM/YYYY") }}</template>
        </template>
      </p>

      <!-- Uma única lista, refiltrada pelo pill/data ativos -->
      <PsychologistsList :propFilters="activeFilters" />
    </Container>
  </div>
</template>

<script>
import PsychologistsController from "./PsychologistsController";
export default PsychologistsController;
</script>

<style scoped>
.pills-wrap {
  display: flex;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 10px;
}
.filter-pill {
  border: 1px solid var(--bs-border-color, #e3e8ef);
  background-color: #fff;
  color: var(--bs-body-color, #4a5568);
  border-radius: 999px;
  padding: 7px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.15s ease;
}
.filter-pill--idle:hover {
  border-color: var(--bs-primary);
  color: var(--bs-primary);
}
.filter-pill--active {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary);
  color: #fff;
  box-shadow: 0 4px 10px rgba(251, 164, 134, 0.35);
}
.pill-badge {
  font-size: 0.72rem;
  font-weight: 700;
  background-color: var(--bs-gray-200, #eef2f8);
  color: var(--bs-gray-700, #5a6b82);
  border-radius: 999px;
  padding: 1px 8px;
  min-width: 22px;
  text-align: center;
}
.filter-pill--active .pill-badge {
  background-color: rgba(255, 255, 255, 0.28);
  color: #fff;
}
</style>
